import { useEffect, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { inventoryApi, stockPointAccessApi } from './api';

export function defaultStockPointId(points: ReadonlyArray<{id: number}>, selectedId: string, defaultToFirst = false) {
  if (selectedId || !points.length || (!defaultToFirst && points.length !== 1)) return undefined;
  return String(points[0].id);
}

export function useAssignedStockPoints(selectedId: string, setSelectedId: (value: string) => void, options?: {defaultToFirst?: boolean}) {
  const all = useQuery({ queryKey: ['stock-points'], queryFn: inventoryApi.stockPoints });
  const assigned = useQuery({ queryKey: ['my-stock-points'], queryFn: stockPointAccessApi.mine });
  const points = useMemo(() => {
    const ids = new Set(assigned.data ?? []);
    return (all.data ?? []).filter(point => ids.has(point.id));
  }, [all.data, assigned.data]);
  const defaultToFirst = options?.defaultToFirst ?? false;
  useEffect(() => {
    if (all.isLoading || assigned.isLoading || all.isError || assigned.isError) return;
    const next = defaultStockPointId(points, selectedId, defaultToFirst);
    if (next) setSelectedId(next);
  }, [points, selectedId, setSelectedId, defaultToFirst, all.isLoading, assigned.isLoading, all.isError, assigned.isError]);
  return { points, isLoading: all.isLoading || assigned.isLoading, isError: all.isError || assigned.isError };
}
